module.exports = __webpack_public_path__ + "static/media/hardwareEditIcon.5c60197a.svg";